// extracted by mini-css-extract-plugin
module.exports = {"menusUploadsDropZones":"MenusSalesDropZoneWrp_menusUploadsDropZones__23qIU","menusUploads":"MenusSalesDropZoneWrp_menusUploads__2xeMm"};